"use strict";
exports.__esModule = true;
var angular = require("angular");
var COMPONENT_NAME = 'smartorg.r6.navs.treeFilter';
function copy(obj) {
    if (!obj) {
        return obj;
    }
    return JSON.parse(JSON.stringify(obj));
}
var TreeFilterModalComponent = /** @class */ (function () {
    function TreeFilterModalComponent(shareLink) {
        this.shareLink = shareLink;
        this.lastUpdatedLegends =
            '<div style="display: flex; line-height: 25px;">' +
                '<span style="background-color: #153a42; height: 10px; width: 10px; margin: 7px;"></span>' +
                '<span>Updated within 30 days</span>' +
                '</div>' +
                '<div style="display: flex; line-height: 25px;">' +
                '<span style="background-color: #387684; height: 10px; width: 10px; margin: 7px;"></span>' +
                '<span>Updated within 90 days</span>' +
                '</div>' +
                '<div style="display: flex; line-height: 25px;">' +
                '<span style="background-color: #69b5c7; height: 10px; width: 10px; margin: 7px;"></span>' +
                '<span>Updated within 180 days</span>' +
                '</div>' +
                '<div style="display: flex; line-height: 25px;">' +
                '<span style="background-color: white; height: 10px; width: 10px; margin: 7px; border-style: solid; border-width: thin;"></span>' +
                '<span>Updated on or before 180 days</span>' +
                '</div>';
        this.excludeFilter = false;
    }
    TreeFilterModalComponent.prototype.$onChanges = function () {
        // this.filterQuery = this.initFilterQuery;
        // this.excludedTags = angular.copy(this.initExcludedFilterTags);
        this.defaultFilterQuery = this.shareLink.getDefaultTreeFilters();
        this.defaultExcludeQuery = this.shareLink.getDefaultTreeExcludeFilters();
        this.filterQuery = this.shareLink.getTreeFilters() != undefined ? this.shareLink.getTreeFilters() : this.defaultFilterQuery;
        this.excludedTags = this.shareLink.getTreeExcludeFiltersWithoutNull() != undefined ? this.shareLink.getTreeExcludeFilters() : this.defaultExcludeQuery;
    };
    TreeFilterModalComponent.prototype.updateFilter = function (filterQuery, excludedTags) {
        this.filterQuery = filterQuery;
        this.excludedTags = angular.copy(excludedTags);
        this.initFilterQuery = copy(this.filterQuery);
        this.initExcludedFilterTags = angular.copy(this.excludedTags);
    };
    TreeFilterModalComponent.prototype.doneFilter = function () {
        this.initFilterQuery = this.filterQuery;
        this.reloadTreeAndApplyFilter({
            showTreeColors: this.showTreeColors,
            filterLogic: this.filterQuery,
            excludedTags: this.excludedTags
        });
        this.initExcludedFilterTags = angular.copy(this.excludedTags);
    };
    TreeFilterModalComponent.prototype.resetFilter = function () {
        this.filterQuery = copy(this.defaultFilterQuery);
        this.initFilterQuery = copy(this.filterQuery);
        this.excludedTags = angular.copy(this.defaultExcludeQuery);
        this.initExcludedFilterTags = angular.copy(this.excludedTags);
    };
    TreeFilterModalComponent.prototype.focusOnFilter = function () {
        var filterInput = $("#simpleFilterV3").find("input");
        filterInput.focus();
    };
    TreeFilterModalComponent.prototype.saveDefault = function () {
        if (confirm('Save current filters as default, please confirm!')) {
            this.saveDefaultFilter({
                showTreeColors: this.showTreeColors,
                filterLogic: this.filterQuery,
                excludedTags: this.excludedTags
            });
        }
    };
    TreeFilterModalComponent.prototype.excludeFilterSelection = function () {
        this.excludeFilter = !this.excludeFilter;
    };
    TreeFilterModalComponent.$inject = ['shareLink'];
    return TreeFilterModalComponent;
}());
angular.module(COMPONENT_NAME, []).component('treeFilterModal', {
    template: require('./tree-filter-modal.component.html'),
    bindings: {
        modalId: '@',
        showSaveDefault: '<?',
        allTags: '<',
        treeLoaded: "<?",
        allDropdownTags: '<',
        allCategories: '<',
        initFilterQuery: '<',
        initExcludedFilterTags: '<',
        defaultFilterQuery: '<',
        defaultExcludeQuery: '<',
        applyFilter: '&',
        saveDefaultFilter: '&',
        showTreeColors: '<',
        reloadTreeAndApplyFilter: '&'
    },
    controller: TreeFilterModalComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=tree-filter-modal.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/tree-filter-modal/tree-filter-modal.component.js